import { Extension } from '@tiptap/core';

export const ClearMarksOnEnter = Extension.create({
  addKeyboardShortcuts() {
    return {
      Enter: () => {
        const { editor } = this;

        if (editor.isActive('orderedList') || editor.isActive('bulletList')) {
          return false;
        }
        editor
          .chain()
          .command(({ tr }) => {
            tr.setStoredMarks([]);
            return true;
          })
          .splitBlock()
          .run();

        return true;
      },
    };
  },
});
